import actions from "@/modules/categories/store/actions";
import getters from "@/modules/categories/store/getters";
import mutations from "@/modules/categories/store/mutations";

export default {
    state: {},
    actions: actions,
    getters: getters,
    mutations: mutations
}